import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const Guard = ({isRouteAccessible = false, redirectRoute = '/login'}) =>
    isRouteAccessible ? <Outlet /> : <Navigate to={redirectRoute} replace />;

export default Guard;